import { useMemo, useState } from 'react';
import { usePostboxCounter } from './usePostboxCounter';

// eslint-disable-next-line import/prefer-default-export
export const useBookitupMailFolderCounts = (contactsIds?: number[] | null) => {
  const [inboxLastUpdated, setInboxCount] = useState<number>(Date.now());
  const [failedLastUpdated, setFailedLastUpdatedCount] = useState<number>(Date.now());
  const [scheduledLastUpdated, setScheduledLastUpdated] = useState<number>(Date.now());
  const [unreadLastUpdated, setUnreadLastUpdatedCount] = useState<number>(Date.now());

  const inboxCount = usePostboxCounter('inbox', inboxLastUpdated, undefined, contactsIds);
  const failedCount = usePostboxCounter('failed', failedLastUpdated, undefined, contactsIds);
  const scheduledCount = usePostboxCounter('scheduled', scheduledLastUpdated, undefined, contactsIds);
  const unreadCount = usePostboxCounter('inbox', unreadLastUpdated, 'unread', contactsIds);

  const refreshCount = (box?: string) => {
    if (!box) {
      setInboxCount(Date.now());
    }
    if (box === 'unread') {
      setUnreadLastUpdatedCount(Date.now());
    }
    if (box === 'failed') {
      setFailedLastUpdatedCount(Date.now());
    }
    if (box === 'scheduled') {
      setScheduledLastUpdated(Date.now());
    }
  };

  const value = useMemo(
    () => ({
      unreadCount,
      inboxCount,
      failedCount,
      scheduledCount,
      refreshCount,
    }),
    [unreadCount, inboxCount, failedCount, scheduledCount],
  );
  return value;
};
